module.exports = __webpack_public_path__ + "media/start_1.0b53a770.mp3";